import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import AppUtil from "utilities/AppUtil";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";

// Main URL Endpoint
const _urlPrefix = "/actions";

export const fetchPageAction = createAsyncThunk(
  "action/fetchPageAction",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params),
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const createAction = createAsyncThunk(
  "action/createAction",
  async (params) => {
    const { file, ...actionData } = params;
    const data = new FormData();

    if (file) {
      data.append("file", file);
    }

    data.append(
      "content-data",
      new Blob(
        [JSON.stringify(snakecaseKeys(actionData))],
        { type: "application/json" }
      )
    );

    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: data,
      successMessage: "toast.create.200",
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const updateActionStatus = createAsyncThunk(
  "action/updateActionStatus",
  async (params) => {
    const { id, file, ...requestData } = params;
    const data = new FormData();

    if (file) {
      data.append("file", file);
    }

    data.append(
      "content-data",
      new Blob(
        [JSON.stringify(snakecaseKeys(requestData))],
        { type: "application/json" }
      )
    );

    const result = await httpRequest({
      url: `${_urlPrefix}/${id}/status`,
      method: "PUT",
      headers: { "Content-Type": "multipart/form-data" },
      data: data,
      successMessage: "toast.update.200",
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  list: [],
  totalElements: 0,
  totalPages: 0,
  pageNumber: 1,
};

const action = createSlice({
  name: "action",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchPageAction.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.list = payload.content;
        state.totalElements = payload.totalElements;
        state.totalPages = payload.totalPages;
        state.pageNumber = payload.pageNumber;
      }
    },
  },
});

const { reducer } = action;
export default reducer;

export const getActionList = createSelector(
  (state) => state.action.list,
  (list) => list
);
